export default __webpack_public_path__ + "static/media/head03_th_sp.683021fe.png";